import React from 'react';
import PlayerAvatar from 'components/ui/PlayerAvatar';
import { t } from 'utilities/TranslationUtils';
import { RecentPlayer } from './playerPerformanceUtils';

interface PlayerChipProps {
  player: RecentPlayer;
  onClick: () => void;
}

/** A roster cell: avatar, name, team and "N sessions · N kicks". */
const PlayerChip: React.FunctionComponent<PlayerChipProps> = ({ player, onClick }) => (
  <button type='button' className='pp-chip' data-test='pp-player-chip' title={player.name} onClick={onClick}>
    <PlayerAvatar name={player.name} imageUrl={player.avatarUrl} size='lg' colorKey={player.teamName} />
    <span className='pp-chip-body'>
      <span className='pp-chip-name'>{player.name}</span>
      {player.teamName && <span className='pp-chip-team'>{player.teamName}</span>}
      <span className='pp-chip-stats' data-test='pp-player-stats'>
        {t('playerPerformance.playerSessionsCount', { count: player.sessionCount })} · {t('playerPerformance.kicks', { count: player.kickCount })}
      </span>
    </span>
  </button>
);

export default PlayerChip;
